import React from 'react';
import Grid from '@mui/material/Grid';
import { Typography, Divider } from '@raisin/components-lib';
import * as S from './styles';
import { OfferDetailField } from './types';

export interface BankOffersDetailFieldProps {
  field: OfferDetailField;
}

const BankOffersDetailField: React.FC<BankOffersDetailFieldProps> = ({ field }) => {
  if (!field.isVisible) return null;

  return (
    <Grid item xs={12} lg={field?.fullWidth ? 10 : 5} my={6}>
      {field.title && (
        <>
          <S.Title mb={2} variant="subtitle1">
            {field.title}
          </S.Title>
          <Divider light />
        </>
      )}
      {field?.isHTMLContentAvailable ? (
        <Typography sx={{ mt: 1, whiteSpace: 'pre-line' }} variant="body2">
          <div
            dangerouslySetInnerHTML={{
              __html: field.value,
            }}
          />
        </Typography>
      ) : (
        <Typography sx={{ mt: 1, whiteSpace: 'pre-line' }} variant="body2">
          {field.value}
        </Typography>
      )}
    </Grid>
  );
};

export default BankOffersDetailField;
